<div
  [class]="'progress-container ' + 'current-sked-progress-' + priorityText | lowercase"
  [style.width.px]="diameter"
  [style.height.px]="diameter"
>
  <mat-progress-spinner
    class="progress"
    color="#fff"
    mode="determinate"
    [value]="percentComplete"
    [diameter]="diameter"
    [strokeWidth]="strokeWidth"
  >
  </mat-progress-spinner>
  <ng-content></ng-content>
</div>
